<div class="camera-group" >
   <app-tree-view-item 
      (eventChild)="parentSelected($event)"
      (eventIsClick)="getIsClick($event)"
      (eventSubChild)="getSubIdparent($event)"
      (bunchOutput)="getBunchLive($event)"
      (camera)="getCameraLive($event)"
    *ngFor="let bunch of listBunch"  [bunch]="bunch" [term]="search"></app-tree-view-item>
</div>